/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Sync_Ignore_SuccessInputs */

const vi_toast_expense_sync_ignore_success = /** @type {(inputs: Toast_Expense_Sync_Ignore_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bỏ qua giao dịch`)
};

/**

* @param {Toast_Expense_Sync_Ignore_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_sync_ignore_success = /** @type {((inputs?: Toast_Expense_Sync_Ignore_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Sync_Ignore_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_sync_ignore_success(inputs)
});